import { render, staticRenderFns } from "./simulador-comparativo.vue?vue&type=template&id=5cbf4991&"
import script from "./simulador-comparativo.vue?vue&type=script&lang=js&"
export * from "./simulador-comparativo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cbf4991')) {
      api.createRecord('5cbf4991', component.options)
    } else {
      api.reload('5cbf4991', component.options)
    }
    module.hot.accept("./simulador-comparativo.vue?vue&type=template&id=5cbf4991&", function () {
      api.rerender('5cbf4991', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modal/workspace/simulador-comparativo.vue"
export default component.exports